<template>
  <SearchFile
    :label="label"
    selectYourElementText="Sélectionnez votre pharmacie dans la liste"
    elementNonRepertorieText="Ma pharmacie n'est pas répertoriée"
    noResultsFoundText="Aucune pharmacie trouvée. Si vous ne trouvez pas la pharmacie en question, contactez-nous."
    :searchUrl="
      (keyword) =>
        `/organisations/search-achat?keyword=${keyword}${
          isAcquereur ? '&isAcquereur=true' : ''
        }`
    "
    @elementSelected="organisationSelected"
    :fillKeywordAfterSelect="(element) => element.organisation"
    :rules="rules"
    :filterResults="filterResults"
    maxWidth="670"
  >
    <template v-slot:cardContent="{ element }">
      <OrganisationCardContent :organisation="element" />
    </template>
  </SearchFile>
</template>

<script>
import SearchFile from "@/components/Common/SearchFile"
import OrganisationCardContent from "@/components/Common/OrganisationCardContent"
export default {
  components: { SearchFile, OrganisationCardContent },
  props: {
    isStage: { type: Boolean, default: false },
    rules: Array,
    idToExclude: Array,
    label: {
      type: String,
      default:
        "Saisissez le nom ou l'adresse de la pharmacie dont vous déclarez l'achat",
    },
  },
  methods: {
    organisationSelected(organisation) {
      this.$emit("organisation-selected", { ...organisation })
    },
    filterResults(item) {
      if (this.idToExclude) {
        return this.idToExclude.indexOf(item.organisationId) === -1
      }
      return null
    },
  },
}
</script>
